module.exports = __webpack_public_path__ + "img/ზანდა.5c779feb.png";